export const loaderTypes = {
    CHANGE_GLOBAL_LOADER: "loader/CHANGE_GLOBAL_LOADER",
};
